<template>
  <CCarousel
    :images="data?.images?.map((i) => i.url) ?? []"
    :includeAllImagesInPdf="data?.include_all_images_in_pdf"
    :placeholder-height="data?.placeholder_height"
    :preview-disabled="isEditMode"
    :style="style"
  />
</template>
<script lang="ts" setup>
import type { CSSProperties } from 'vue'

import useCanvas from '@canvas-builder/composables/useCanvas'
import CCarousel from '@lib/components/CCarousel/CCarousel.vue'
import type { CarouselProps } from '@canvas-builder/types/canvas'

defineProps<{
  data?: CarouselProps
  style?: CSSProperties
}>()

const { isEditMode } = useCanvas()
</script>
